// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__22-j0","savePackageButton":"ClientWallet_savePackageButton__36eKK"};